import { render, staticRenderFns } from "./satsList.vue?vue&type=template&id=75217cd8&scoped=true&"
import script from "./satsList.vue?vue&type=script&lang=js&"
export * from "./satsList.vue?vue&type=script&lang=js&"
import style0 from "./satsList.vue?vue&type=style&index=0&id=75217cd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75217cd8",
  null
  
)

export default component.exports